import React, { useState, useEffect } from 'react';
import { Bell, User, ChevronDown, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  const currentTime = new Date().toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  });

  // Fetch user profile once on header render
  useEffect(() => {
    const fetchUserData = async () => {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.error('No auth token found in localStorage');
        setUserData({ username: 'No token found' });
        return;
      }

      try {
        const response = await fetch(' https://sadaatagrofarms.com/api/users/profile/', {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error(error);
        setUserData({ username: 'Error fetching data' });
      }
    };

    fetchUserData();
  }, []); // empty dependency → runs once on mount

  const handleUserClick = () => {
    setIsModalOpen(true); // just open modal, no API call here
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="time-display">
          <span className="time">{currentTime}</span>
          <span className="timezone">(Europe/Amsterdam)</span>
        </div>
      </div>

      <div className="header-right">
        <button className="header-btn notification-btn">
          <Bell size={20} />
          <span className="notification-badge">2</span>
        </button>

        <div className="user-menu" onClick={handleUserClick}>
          <div className="user-avatar">
            <User size={20} />
          </div>
          <div className="user-info">
            <span className="user-name">{userData ? userData.username : 'Loading...'}</span>
            <span className="user-role">Active farm</span>
          </div>
          <ChevronDown size={16} />
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlayheader" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <X size={16} />
            </button>
            {userData ? (
              <div className="modal-contentheader">
                <h2>{userData.username}</h2>
                <p>Email: {userData.email || 'Not provided'}</p>
                <p>Mobile: {userData.mobile_number || 'Not provided'}</p>
                <p>Role: {userData.is_staff ? 'Staff' : 'User'}</p>
                <p>Status: {userData.is_active ? 'Active' : 'Inactive'}</p>
                <p>Created At: {new Date(userData.created_at).toLocaleString()}</p>
              </div>
            ) : (
              <p>Loading user data...</p>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
